import Joi from '@hapi/joi';
import { ProductCode } from 'types';
import validate from './validate';

export const schema = Joi.object<Partial<ProductCode>>({
  name: Joi.string().required().messages({
    'string.empty': 'REQUIRED_FIELD',
  }),
});

export default function (value: Partial<ProductCode>) {
  return validate(schema, value, {
    allowUnknown: true,
    context: {},
  });
}
